<template>
  <div v-if="loading">
    <loader></loader>
  </div>
  <div v-else>
    <div class="row">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" aria-current="page">{{ request.objectId }}</li>
          <li class="breadcrumb-item" aria-current="page">{{ step.name }}</li>
        </ol>
      </nav>
       <h1 style="display: inline-block">Convites </h1>
       <router-link style="margin-top: -10px" :to="{name: 'RequestInviteSelect'}" type="button" class="btn btn-sm btn-primary">
          <span class="glyphicon glyphicon-plus"></span> Adicionar Convidado
        </router-link>
    </div>
  <hr/>
    <div class="row">
      <div v-if="!invites || invites.length === 0" class="alert alert-info">
        Nenhum convite criado.
      </div>
      <b-table v-else :items="invites" :fields="requestsfields" striped hover>
        <span slot="user" slot-scope="item">
            <span v-if="item.value.get">{{item.value.get('name')}}</span>
        </span>
        <span slot="expiration" slot-scope="item">
            <span v-if="item.value" :class="{ danger: new Date(item.value) < new Date() }">{{formatExpirationDate(item.value)}}</span><span v-else>Não</span>
        </span>
        <span slot="canComment" slot-scope="item">
            <span v-if="item.value">Sim</span><span v-else>Não</span>
        </span>
        <span slot="canEdit" slot-scope="item">
            <span v-if="item.value">Sim</span><span v-else>Não</span>
        </span>
        <span slot="createdAt" slot-scope="item">
            {{formatDate(item.value)}}
        </span>
        <span slot="actions" slot-scope="item">
          <button class="btn btn-danger btn-xs" @click="remove(item.item.objectId)">Remover</button>
        </span>
      </b-table>
      <hr/>
    </div>
    <div class="row">
      <button class="btn btn-default" @click="$router.go('-1')">Voltar</button>
    </div>
  </div>
</template>

<script>

import Loader from './util/Loader'
import moment from 'moment'
import { Parse, miniToastr } from '../Global'
import { handleParseError } from './util/ErrorHandling'
moment.locale('pt-br')

export default {
  components: {
    Loader
  },
  data () {
    return {
      loading: false,
      requestsfields: {
        user: { label: 'Usuário', sortable: true },
        expiration: { label: 'Expira', sortable: true },
        canComment: { label: 'Pode comentar?', sortable: true },
        canEdit: { label: 'Pode editar?', sortable: true },
        createdAt: { label: 'Criado', sortable: true },
        actions: { label: 'Ações' }
      },
      invites: [],
      request: {},
      step: {}
    }
  },
  mounted () {
    let requestId = this.$route.params.requestId
    let stepId = this.$route.params.stepId
    this.load(requestId, stepId)
  },
  methods: {
    /**
    * Carrega de forma assíncrona informações adicionais sobre o Request e o Step em questão (nome etc.)
    **/
    load (requestId, stepId) {
      let self = this
      self.loading = true
      let params = {
        requestId: requestId,
        stepId: stepId
      }
      Parse.Cloud.run('requestInviteInfo', params).then(results => {
        self.loading = false
        self.request = results.request
        self.step = results.step
        self.invites = results.invites
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    formatExpirationDate (date) {
      return moment(new Date(date)).format('DD/MM/YYYY')
    },
    formatDate (date) {
      return moment(new Date(date)).fromNow()
    },
    /**
    * Remove convite de um usuário
    **/
    remove (item) {
      if (confirm('Deseja realmente remover o convite?')) {
        let self = this
        self.loading = true
        let params = { inviteId: item,
          requestId: self.request.objectId }
        Parse.Cloud.run('cancelInvite', params).then(() => {
          miniToastr.success('Removido com successo.')
        }).fail(error => {
          console.log(error)
          miniToastr.error('Erro ao remover convite.')
        }).always(() => {
          self.loading = false
          self.load(self.request.objectId, self.step.objectId)
        })
      }
    }
  }
}
</script>

<style scoped>
.danger {
  color: red;
}
</style>



// WEBPACK FOOTER //
// RequestInvite.vue?7a1d3ed0